module.exports = __webpack_public_path__ + "img/camera_enhance.082888b9.svg";